import { render, staticRenderFns } from "./Component.vue?vue&type=template&id=2b6348cb&scoped=true"
import script from "./Component.vue?vue&type=script&lang=ts"
export * from "./Component.vue?vue&type=script&lang=ts"
import style0 from "./Component.vue?vue&type=style&index=0&id=2b6348cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6348cb",
  null
  
)

export default component.exports